/**
 * App's binding to the shared i18n engine.
 *
 * The engine (shared/i18n) is common to both web surfaces; the catalogues in
 * ./messages are App's alone. This file is the only place that knows both.
 */
import { createI18n } from "@lura/i18n";
import { catalogues, en, LOCALES as LOCALE_LIST, type Locale, type MessageKey } from "./messages";

export type { Locale, MessageKey };
export { LOCALE_LIST as LOCALES };

/**
 * Where a chosen locale is remembered for THIS surface.
 *
 * Surface-qualified because app.uselura.com and book.uselura.com are separate
 * ORIGINS: localStorage does not cross them, so a shared key would imply a
 * carry-over that cannot happen. Exported so tests name the same constant the
 * engine is configured with rather than repeating the literal.
 */
export const STORAGE_KEY = "lura.app.locale";

export const i18n = createI18n<Locale, MessageKey>({
  defaultLocale: "en",
  source: en,
  catalogues,
  storageKey: STORAGE_KEY,
});

export const detectLocale = i18n.detectLocale;
export const setLocale = i18n.setLocale;
export const translate = i18n.translate;
export const formatters = i18n.formatters;
